import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from '@environment';

@Injectable()
export class ReportingOverviewGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    // Only allow access to the overview page in development environment
    if (environment.development && !environment.production) {
      return true;
    }

    // Navigate to talents page (the next reporting section)
    this.router.navigateByUrl('reporting/talents');

    return false;
  }
}
